export const fetchJson = async (url: string) => {
  const res = await fetch(url);
  if (res.status !== 200) {
    return { status: res.status, statusText: res.statusText };
  }
  const json = await res.json();
  return { ...json, status: res.status };
};
